import { tutorial } from "./tutorial";
import { notificaciones } from "./notificaciones";

export const posts = [tutorial, notificaciones];
